// Kept as a re-export for backward compatibility. Loading the Footer eagerly
// avoids a Suspense boundary that was delaying hydration and swallowing
// early clicks on above-the-fold interactive elements (hero search).
import { Footer } from "./Footer";

export const LazyFooter = () => <Footer />;
